export default "__VITE_PUBLIC_ASSET__ba564819__"